import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";
import AuditPage from "@/pages/AuditPage";
import ReportPage from "@/pages/ReportPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SignupPage from "@/pages/SignupPage";
import UserLoginPage from "@/pages/UserLoginPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import ClientDashboard from "@/pages/ClientDashboard";
import AuthCallback from "@/pages/AuthCallback";
import PricingPage from "@/pages/PricingPage";
import SharedReportPage from "@/pages/SharedReportPage";
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import NotFoundPage from '@/pages/NotFoundPage';
import GlobalChatWidget from '@/components/GlobalChatWidget';

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen bg-background">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/audit" element={<AuditPage />} />
            <Route path="/report/:placeId" element={<ReportPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/login" element={<UserLoginPage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<ClientDashboard />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/shared/:shareToken" element={<SharedReportPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/settings" element={<AdminDashboard />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        <GlobalChatWidget />
      </div>
    </AuthProvider>
  );
}

export default App;
